/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Box, Button } from "@mui/material"
import { getDoc, updateDoc, doc, collection, DocumentSnapshot } from "firebase/firestore"
import { db } from "../firebase"
import { toast } from 'react-toastify'
import dayjs from "dayjs"
import { StepFormConfirm } from "./lib/StepFormConfirm"
import { FormProps } from "./lib/StepForm"

const HunterRegistrationConfirm = () => {
  const urlParams = useParams<{ hunterId: string }>()
  const [values, setValues] = useState<Record<string, string|number>>({})
  const [forms, setForms] = useState<Array<FormProps>>([])
  const navigate = useNavigate()

  useEffect(() => {
    getDoc(doc(collection(db, 'forms'), 'hunter')).then((_: DocumentSnapshot) => {
      _.exists() && setForms(_.data().conf)
    })
    const storageValues = sessionStorage.getItem('hunter')
    storageValues && setValues(JSON.parse(storageValues))
  }, [])

  const onSave = () => {
    updateDoc(doc(collection(db, 'hunters'), urlParams.hunterId), {...values, updatedAt: dayjs().format('YYYY/MM/DD HH:mm'), status: "registed"}).then(() => {
      toast.success("狩猟者情報を登録しました")
      sessionStorage.removeItem('hunter')
      setValues({})
      navigate("/")
    }).catch(e => {
      toast.error(e)
    })
  }

  return (
    <Box>
      <StepFormConfirm forms={forms} values={values}/>
      <Box mt={2} display="flex" justifyContent="center">
        <Button variant="outlined" onClick={() => navigate(`/hunters/${urlParams.hunterId}/regist`)}>戻る</Button>
        <Button variant="contained" onClick={onSave} sx={{ ml: 2 }}>登録</Button>
      </Box>
    </Box>

  )
}

export default HunterRegistrationConfirm
